<template>
  <el-dialog
    :title="title"
    :visible="visible"
    append-to-body
    width="70%"
    @open="initFromProps"
    @close="handleClose"
  >
    <div>
      <div
        v-for="(config, index) in submissionConfigs"
        :key="config.value"
        :style="{ marginBottom: '10px', marginTop: index > 0 ? '16px' : '0' }"
      >
        <div style="margin-bottom: 10px; font-weight: bold">
          {{ config.label }}
        </div>
        <el-checkbox-group v-model="categoryLists[config.categoryListKey]">
          <el-checkbox
            v-for="item in categoryOptions"
            :key="item.value + '-' + config.value"
            :label="item.value"
          >
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "SubmissionCategoryDialog",
  props: {
    title: { type: String, default: "按品类设置提交方式" },
    visible: { type: Boolean, default: false },
    categoryOptions: { type: Array, default: () => [] },
    // 提交方式配置列表
    // 格式: [{ value: 'manualUpload', label: '手工上传', categoryListKey: 'manualUploadCategoryList' }]
    submissionConfigs: { type: Array, default: () => [] },
    // 初始数据
    // 格式: { manualUploadCategoryList: [], onlineProcessingCategoryList: [] }
    initialData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      // 动态存储各个提交方式对应的品类列表
      categoryLists: {},
    };
  },
  methods: {
    /**
     * 从 props 初始化数据
     */
    initFromProps() {
      this.categoryLists = {};
      this.submissionConfigs.forEach((config) => {
        const key = config.categoryListKey;
        this.$set(
          this.categoryLists,
          key,
          Array.isArray(this.initialData[key])
            ? [...this.initialData[key]]
            : [],
        );
      });
    },
    /**
     * 关闭对话框
     */
    handleClose() {
      this.$emit("close");
    },
    /**
     * 确认提交
     */
    handleConfirm() {
      // 验证是否有品类对应的提交方式未选择
      const errors = [];
      const optionsMap = new Map(
        this.categoryOptions.map((opt) => [opt.value, opt]),
      );

      // 遍历所有提交方式的品类选择，标记已选择的品类
      Object.values(this.categoryLists).forEach((list) => {
        if (Array.isArray(list)) {
          list.forEach((val) => {
            if (optionsMap.has(val)) {
              optionsMap.delete(val);
            }
          });
        }
      });

      // 收集未选择的品类
      optionsMap.forEach((opt) => {
        errors.push(opt.label);
      });

      if (errors.length > 0) {
        this.$message.error(`请选择${errors.join("、")}提交方式`);
        return;
      }

      // 发射确认事件，将所有品类列表数据返回
      this.$emit("confirm", { ...this.categoryLists });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// SubmissionCategoryDialog.vue?da1cc5cc